import React from 'react'
import theme from 'stories/utils/theme'
import { ComponentContainer } from 'components/layouts/Layouts.css'
import styled from 'styled-components'
import FooterCloud from 'assets/pro-plan/footer_cloud.webp'

const Container = styled.div`
    background-color: transparent;
    background-size: cover;
    background-repeat: no-repeat;
    height: 500px;
    position: relative;
    width: 105%;
    left: -30px;
    bottom: -10px;
    overflow: hidden;
    @media (max-width: 900px) {
        display: none;
    }
`

const VariantPlusPlanFooterCloud = () => {
    return (
        <ComponentContainer color={theme.colors.transparent}>
            <Container style={{ backgroundImage: `url(${FooterCloud.src}` }} />
        </ComponentContainer>
    )
}

export default VariantPlusPlanFooterCloud
